import type { FeedbackAnswerQuestionVoice } from '@repo/types/questions/QuestionVoice';

import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import {
  QuestionMarkedExplanationField,
  QuestionMarkedFormActions,
  QuestionMarkedPointsField,
  QuestionMarkedResponseCard,
  QuestionMarkedResponseContent,
  QuestionMarkedResponseHeader,
} from '@/components/features/quiz/question/question-marked/QuestionMarked';
import { Form } from '@/components/ui/form';
import { AudioPlayer } from '@/components/ui/media-player';

import type { QuestionMarkedVoiceFormProps } from '.';

export function QuestionMarkedVoiceForm(questionMarkedVoiceFormProps: QuestionMarkedVoiceFormProps) {
  const { marked, answerSrc, isOpen, onClose, onSubmit: _onSubmit, maxPoints } = questionMarkedVoiceFormProps;
  const form = useForm<FeedbackAnswerQuestionVoice>({
    defaultValues: {
      points: 0,
      explanation: null,
      correct: false,
      marked: false,
    },
  });

  const onSubmit = (data: FeedbackAnswerQuestionVoice) => {
    onClose();
    _onSubmit?.({ ...data, marked: true, correct: true });
  };

  useEffect(() => {
    if (isOpen && marked) {
      form.reset(marked);
    }
  }, [isOpen, marked, form]);

  return (
    <Form {...form}>
      <form className={'flex w-full flex-col gap-3 p-3'} onSubmit={form.handleSubmit(onSubmit)} noValidate>
        <QuestionMarkedResponseCard>
          <QuestionMarkedResponseHeader>
            <div />
            <QuestionMarkedPointsField control={form.control} name="points" maxPoints={maxPoints} />
          </QuestionMarkedResponseHeader>
          <QuestionMarkedResponseContent>
            <AudioPlayer src={answerSrc} />
          </QuestionMarkedResponseContent>
          <QuestionMarkedExplanationField control={form.control} name="explanation" />
        </QuestionMarkedResponseCard>
        <QuestionMarkedFormActions onClose={onClose} />
      </form>
    </Form>
  );
}
